import styled, { css } from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import Button from "../ui/Button";
import { UIProps } from "~/types/style";

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff4eb;
  padding: ${getSize(1.0)};
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  flex-wrap: wrap;

  ${responsive("tablet", true)} {
    bottom: 64px;
  }
`;

export const Text = styled.span`
  font-weight: 500;
  font-size: ${getSize(1.3)};
  line-height: ${getSize(2.0)};
`;

export const ReconnectButton = styled(Button)`
  color: ${getColor("white")};
  background-color: #ff7300;
  border-radius: ${getSize(0.8)};
  min-width: ${getSize(9.0)};
  font-weight: 500;
`;

interface ISectionContainer extends UIProps {
  wrap?: boolean;
}

export const SectionContainer = styled.div<ISectionContainer>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  ${({ wrap }) =>
    wrap &&
    css`
      flex-wrap: wrap;
    `}
`;
